import type { CommitmentItem } from '../types';

const STORAGE_KEY = 'ced_notified_date';

function fmt(amount: number) {
  return amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export async function requestNotificationPermission(): Promise<NotificationPermission> {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'denied';
  if (Notification.permission !== 'default') return Notification.permission;
  return Notification.requestPermission();
}

export async function checkAndNotifyUpcomingExpenses(items: CommitmentItem[]): Promise<void> {
  if (typeof window === 'undefined' || !('Notification' in window)) return;

  const today = new Date().toDateString();
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === today) return;
  } catch { return; }

  const permission = await requestNotificationPermission();
  if (permission !== 'granted') return;

  const nowMs = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
  const upcoming = items.filter(item => {
    if (item.status === 'paid' || item.type === 'income') return false;
    if (!item.dueDate) return false;
    const dueMs = new Date(`${item.dueDate}T12:00:00`).getTime();
    const days = Math.round((dueMs - nowMs) / 86400000);
    return days >= 0 && days <= 2;
  });

  if (upcoming.length === 0) return;

  try { sessionStorage.setItem(STORAGE_KEY, today); } catch {}

  const title = upcoming.length === 1 ? 'Conta vencendo em breve' : `${upcoming.length} contas vencem em breve`;
  const body = upcoming.length === 1
    ? `${upcoming[0].name} · ${fmt(upcoming[0].amount)}`
    : upcoming.slice(0, 3).map(i => i.name).join(', ');

  new Notification(title, { body, icon: '/icon-192.png' });
}
